import axios from 'axios';

export interface DataComemorativa {
  id: string;
  tenant_id: string;
  /** Formato MM-DD: a data se repete todo ano. */
  dia_mes: string;
  titulo: string;
  tipo: 'civica' | 'setorial' | 'tematica' | 'comunitaria' | 'direitos';
  acao_sugerida?: string;
  tag?: string;
  ativa: boolean;
  created_at: string;
  updated_at: string;
}

const API_URL = import.meta.env.VITE_API_URL || '/api';
const auth = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export const datasApi = {
  /** Sem `dias`, devolve o calendário inteiro; com, só a janela a partir de hoje. */
  list: async (token: string, dias?: number) => {
    const res = await axios.get<DataComemorativa[]>(`${API_URL}/gab/datas`, {
      ...auth(token),
      params: dias ? { dias } : undefined,
    });
    return res.data;
  },

  create: async (data: Partial<DataComemorativa>, token: string) => {
    const res = await axios.post<DataComemorativa>(`${API_URL}/gab/datas`, data, auth(token));
    return res.data;
  },

  update: async (id: string, data: Partial<DataComemorativa>, token: string) => {
    const res = await axios.put<DataComemorativa>(`${API_URL}/gab/datas/${id}`, data, auth(token));
    return res.data;
  },

  delete: async (id: string, token: string) => {
    await axios.delete(`${API_URL}/gab/datas/${id}`, auth(token));
  },
};
